import { render, staticRenderFns } from "./StatisticsTableCardProducts.vue?vue&type=template&id=1fbd46ed&"
import script from "./StatisticsTableCardProducts.vue?vue&type=script&lang=js&"
export * from "./StatisticsTableCardProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports